/* eslint-disable no-warning-comments */
// define([
//     'text!edge/common/config/ml-modifier-validation-messages.json'
// ], (MLModifierValidationMessages)

// const modifierValidationMessages = JSON.parse(MLModifierValidationMessages);

const MLCustomModifierDataType = {
    TYPEKEY_AS_PHONE_TEXT: 'TypeKeyAsPhoneText',
    TYPEKEY_AS_TEXT: 'TypeKeyAsText',
    TYPEKEY_AS_STATE: 'TypeKeyAsState'
};

const MLModifierIds = {
    haveAutoPolicy: 'zsgj2hgo2umsg3rjaeqid2nvjmb',
    homeTheftMonitor: 'zhljmo5d3bq0ka4pk3j2cmsi9j8',
    homeSmokeFire: 'zq1igtq348ad38lh7re5j6chgfb'
};

const MLRatingLimits = {
    modifierButtonLimit: 2,
    buttonLimit: 3,
    charLimit: 14
}

const MLModifierCodes = {
    connectedCar: 'PAConnectedCar_ML',
    connectedCarConsent: 'PAConnectedCarConsentAuthorization_Ext'
};

const isCustomValueType = (valueType) => {
    return Object.values(MLCustomModifierDataType).indexOf(valueType) !== -1;
};

const isPhoneTextModifier = (valueType) => {
    return valueType === MLCustomModifierDataType.TYPEKEY_AS_PHONE_TEXT;
};

const isTextModifier = (valueType) => {
    return valueType === MLCustomModifierDataType.TYPEKEY_AS_TEXT;
};

const isStateModifier = (valueType) => {
    return valueType === MLCustomModifierDataType.TYPEKEY_AS_STATE;
};

const getErrorMessage = (mod) => {
    // TODO: no message defined in ml-modifier-validation-messages.json ?
    // return modifierValidationMessages[mod.codeIdentifier_ML.value];
    return mod.codeIdentifier_ML.value;
};

export default {
    isPhoneTextModifier: isPhoneTextModifier,
    isTextModifier: isTextModifier,
    isStateModifier: isStateModifier,
    isCustomValueType: isCustomValueType,
    getErrorMessage: getErrorMessage,
    MLModifierIds: MLModifierIds,
    MLRatingLimits: MLRatingLimits,
    MLModifierCodes: MLModifierCodes
};
